import { render, staticRenderFns } from "./AddNewAvoirModalNewUi.vue?vue&type=template&id=456f2c60&"
import script from "./AddNewAvoirModalNewUi.vue?vue&type=script&lang=js&"
export * from "./AddNewAvoirModalNewUi.vue?vue&type=script&lang=js&"
import style0 from "./AddNewAvoirModalNewUi.vue?vue&type=style&index=0&lang=css&"
import style1 from "./avoir-request.css?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports